import { makeLimitedListActions } from 'utils/factory'

const baseTargetPageListActions = makeLimitedListActions('targetPageUserFields', {
  storePath: 'targetPage.userFields',
})
export const fetchTargetUserFields = (pageId, includeArchived) =>
  baseTargetPageListActions.fetch({ pageId, active_only: !includeArchived })
export const dropTargetUserFields = baseTargetPageListActions.drop
